import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { arrayOf, string } from 'prop-types';
import {
  ROLES,
  SITES_NAME,
  BOOKING_PATH,
  CMS_PATH,
  LOGS_PATH,
  MARKETING_PATH,
  USERS_PATH,
  REPORT_PATH,
} from '../utils/constants';
import { getSites } from '../api/sites';
import Loader from '../atoms/Loader';

const Selection = ({ roles }) => {
  const [sites, setSites] = useState([]);
  const [isActive, setIsActive] = useState(false);

  useEffect(async () => {
    const sites = await getSites();
    setSites(sites);
  }, []);

  const navigateTo = (path, roles) => () => {
    let redirectPath = path;
    if (roles?.includes(MARKETING_PATH)) {
      redirectPath = `${MARKETING_PATH}/${path}`;
    }
    window.location.href = `/${redirectPath}`;
  };

  if (sites.length > 0) {
    return (
      <Container>
        <Title>Accedi a</Title>
        <OptionsContainer>
          {roles.includes(ROLES.CMS) && <CmsLink onClick={navigateTo(CMS_PATH)}>CMS Vacanze</CmsLink>}
          {roles.includes(ROLES.BOOKING) && <BookingLink onClick={navigateTo(BOOKING_PATH)}>Booking</BookingLink>}
          {roles.includes(ROLES.USER_MANAGER) && <UsersLink onClick={navigateTo(USERS_PATH)}>Utenti</UsersLink>}
          {roles.includes(ROLES.REPORT) && <ReportLink onClick={navigateTo(REPORT_PATH)}>Report</ReportLink>}
          {roles.includes(ROLES.MARKETING) && (
            <MarketingLink>
              <Text>Marketing</Text>
              <div className={`dropdown ${isActive ? 'is-active' : ''}`}>
                <div className="dropdown-trigger" onClick={() => setIsActive(!isActive)}>
                  <button className="button" aria-haspopup="true" aria-controls="dropdown-menu4">
                    <span>Seleziona un sito</span>
                    <span className="icon is-medium">
                      <i className="mi mi-arrow-drop-down" aria-hidden="true" />
                    </span>
                  </button>
                </div>
                <div className="dropdown-menu" id="dropdown-menu4" role="menu">
                  <div className="dropdown-content">
                    {sites.map((site) => {
                      return (
                        <DropdownHover className="dropdown-item" onClick={navigateTo(site, roles)} key={site}>
                          <p>{SITES_NAME[site]}</p>
                        </DropdownHover>
                      );
                    })}
                  </div>
                </div>
              </div>
            </MarketingLink>
          )}
          {roles.includes('super-admin') && <LogsLink onClick={navigateTo(LOGS_PATH)}>Logs</LogsLink>}
        </OptionsContainer>
      </Container>
    );
  }
  return <Loader />;
};

Selection.propTypes = {
  roles: arrayOf(string).isRequired,
};

export default Selection;

const Container = styled.div`
  padding-top: 64px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #f2f6fa;
  min-height: 100vh;
`;

const Title = styled.h1``;

const Text = styled.h1`
  margin-bottom: 10px;
`;

const DropdownHover = styled.div`
  &:hover {
    background-color: rgba(0, 0, 0, 0.05);
  }
`;

const OptionsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 16px;

  @media (min-width: 768px) {
    gap: 32px;
  }
`;

const Link = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: 1px solid black;
  border-radius: 4px;
  cursor: pointer;
  margin: 16px;

  height: 100px;
  width: 100%;
  max-width: 200px;
  box-sizing: border-box;
  font-size: 16px;
  font-weight: 600;

  @media (min-width: 768px) {
    height: 120px;
    width: 220px;
    font-size: 20px;
  }

  &:hover {
    opacity: 0.85;
  }
`;

const BookingLink = styled(Link)`
  background: #609ea1;
  color: #ffffff;
`;

const CmsLink = styled(Link)`
  background: #f1c232;
  color: #000000;
`;

const LogsLink = styled(Link)`
  background: #cccccc;
  color: #000000;
`;

const MarketingLink = styled(Link)`
  background: #9e7cf9;
  color: #ffffff;
`;

const ReportLink = styled(Link)`
  background: #df5b5b;
  color: #ffffff;
`;

const UsersLink = styled(Link)`
  background: #2b78e4;
  color: #ffffff;
`;

